<template lang="pug">
.container-restricao
    div(
        v-if='restricoes.length > 0',
        :class='restricoes[index].inibido !== "undefined" && restricoes[index].inibido ? "camada-inibida" : ""',
        v-for='(restricao, index) in listaRestricoes'
    )
        slot(name='botaoInibir', :restricao='restricoes[index]')
        .card-restricao
            .container-restricao-acoes(
                v-if='habilitarZoomRestricao && (restricoes[index].geometry || restricoes[index].geometria || geometria)'
            )
                div
                    el-button(
                        size='small',
                        icon='mdi mdi-crosshairs-gps',
                        @click='aplicarZoomRestricao(index)'
                    )
            slot(name='selecionarRestricao', :restricao='restricoes[index]')
            p
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.tipo') }}:
                |
                | {{ restricao.gna }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.nome') }}:
                |
                | {{ restricao.nam }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.ano') }}:
                |
                | {{ restricao.ano }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.provincia') }}:
                |
                | {{ restricao.provincia }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.areaHa') }}:
                |
                | {{ restricao.area_ha }}

                Criticidade(
                    v-if='restricao.nivelAlerta'
                    :restricao='restricao'
                )
</template>
                
<script>
import Criticidade from '@/components/diagnosticoSocioambiental/Criticidade.vue';

export default {
    name: 'apria_reserva_de_la_biosfera',

    emits: ['highlightGeometry'],

    components: {
        Criticidade
    },

    data() {
        return {};
    },

    props: {
        restricoes: {
            type: Array,
            required: true
        },
        geometria: {
            type: Array,
            required: false,
            default: null
        },
        habilitarZoomRestricao: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    computed: {
        listaRestricoes: function () {
            return this.restricoes.map(value => {
                if (value.properties) {
                    return {
                        ...value.properties
                    };
                }
                return value;
            });
        }
    },

    methods: {
        aplicarZoomRestricao(index) {
            let geometriaQueNaoEstavaDentroDasRestricoes = null;
            if (this.geometria) {
                geometriaQueNaoEstavaDentroDasRestricoes =
                    this.geometria[index];
            }
            this.$emit(
                'aplicar-zoom-restricao',
                this.restricoes[index],
                geometriaQueNaoEstavaDentroDasRestricoes
            );
        }
    }
};
</script>
                
<style lang="scss" scoped>
.card-restricao {
    margin-top: 3%;
}
</style>
